import { AUDIO_ONLY_MINIMIZED_AVATAR_IMG } from "@/lib/tour/tourPlayback";
import { RawGuide } from "@common/api/ping";
import { makeObservable, observable } from "mobx";

export class GuideRegistry {
  _guides: RawGuide[] = [];

  constructor() {
    makeObservable(this, {
      _guides: observable.ref,
    });
  }

  setGuides(guides: RawGuide[]) {
    this._guides = guides;
  }

  findById(id: string) {
    return this._guides.find((guide) => guide.id === id);
  }

  getPreviewImageUrl(guideId: string) {
    const guide = this.findById(guideId);
    if (!guide) {
      return AUDIO_ONLY_MINIMIZED_AVATAR_IMG;
    }

    return (
      guide.tour_playback?.previewImageUrl ?? guide.tour_playback?.previewGifUrl ?? AUDIO_ONLY_MINIMIZED_AVATAR_IMG
    );
  }

  getPreviewImageUrls(guideIds: string[]) {
    return guideIds.reduce(
      (acc, id) => {
        acc[id] = this.getPreviewImageUrl(id);
        return acc;
      },
      {} as Record<string, string>
    );
  }

  getTotalGuideLengthInMs(guideIds: string[]) {
    return guideIds.reduce((acc, id) => {
      const guide = this.findById(id);
      return (
        acc + (guide?.tour_playback?.sections?.map((section) => section.mediaDuration).reduce((a, b) => a + b, 0) ?? 0)
      );
    }, 0);
  }

  get guides() {
    return this._guides;
  }
}
